

export const searchParamFormKey =  {
  type: "select",
  model: ["formKey"],
  label: "触发问卷",
  options: `async function ({ quickRequest, domainEnum }) {
    const { data } = await quickRequest({ cache: true, url: domainEnum + '/workOrderLogic/querySimpleFormNameMap' })
    return data;
  }`,
  attrs: {
    clearable: true,
    filterable: true
  },
  propKey: {
    label: "name",
    value: "formKey",
    key: "formKey",
  },
  valueRepeat: 0,
}

export const statusArr = [
  {
    value: 0,
    label: "处理中",
  },
  {
    value: 1,
    label: '已关闭'
  }
]